import { useMemo } from 'react';
import { markdownToHtml } from '../../lib/rich-text-markdown';
import { cn } from '../../lib/utils';

export function MarkdownContent({
  value,
  className,
}: {
  readonly value: string;
  /**
   * Thêm lớp cho khối chữ — chỗ dùng chính là trần độ dài dòng (`max-w-prose`).
   *
   * Trần ấy không đặt sẵn ở đây được: cùng component này vừa hiện mô tả dự án
   * trải hết bề ngang trang, vừa hiện mô tả task trong một ngăn kéo hẹp. Chỗ
   * biết dòng đang dài bao nhiêu là chỗ gọi.
   */
  readonly className?: string;
}) {
  const html = useMemo(() => markdownToHtml(value), [value]);
  return (
    <div
      className={cn('rich-text-content text-sm', className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
